import { ConfirmDialog } from '@/components/ui/ConfirmDialog';

import type { UnsavedChangesControl } from './useUnsavedChanges';

/**
 * The one wording for "you are about to lose your edits", asked the same way
 * on every form.
 *
 * Usually rendered as `<UnsavedChangesDialog {...useUnsavedChanges(isDirty)} />`
 * next to the form's Save button. A dialog that is not a page (the invite
 * dialog) has no navigation to block, so it passes its own state instead.
 *
 * Built on ConfirmDialog, which renders Stay first - so opening the prompt
 * puts focus on the answer that changes nothing - and treats Escape and the
 * backdrop as Stay.
 */
export function UnsavedChangesDialog({ blocked, stay, leave }: UnsavedChangesControl) {
  return (
    <ConfirmDialog
      open={blocked}
      title="Leave without saving?"
      description="Your changes to this page will be lost."
      confirmLabel="Leave"
      cancelLabel="Stay"
      onConfirm={leave}
      onCancel={stay}
    />
  );
}
